import { ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";
import { AuthService } from "./AuthService";
import { Injectable } from "@angular/core";
import { MenuService } from "./MenuService";
import { filter, map, Observable, of, take } from "rxjs";

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

    constructor(
        private authService: AuthService,
        private menuService: MenuService,
        private router: Router
    ) { }

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
        const userType = this.authService.getUserType();
        const requestedUrl = '/' + (route.routeConfig?.path ?? '');

        if (requestedUrl === '/unauthorized') return of(true);

        return this.menuService.menusLoaded$.pipe(
            take(1), // continue even if false
            map(() => {
                const subMenus = this.menuService.getAllSubMenus();
                console.log("SubMenus in Guard:", subMenus);

                // If no menus loaded yet → allow temporarily (prevents blank screen)
                if (!subMenus || subMenus.length === 0) return true;

                const found = subMenus.find(sub =>
                    sub.route.toLowerCase() === requestedUrl.toLowerCase()
                );

                if (!found) {
                    this.router.navigate(['/unauthorized']);
                    return false;
                }

                if (found.admin !== userType || found.counsellor !== userType || found.third_party !== userType) {
                    this.router.navigate(['/unauthorized']);
                    return false;
                }

                return true;
            })
        );
    }

}






